// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"da649c70","211":"0e2bda18","409":"6472431b"}[chunkId] + ".chunk.js";
};